import React, {useEffect, useState} from 'react';
import LoginForm from './components/MgyLandingLoginForm';
import handleLogin from './LoginCommon';
import { notify } from './Helpers';

export default function Login(props) {

	const [show, setShow] = useState(true);

	useEffect(()=> {

		async function checkNIDFromUrl() {

			// get current url
			const url = new URL(window.location.href);

			// option 1. get NID from path
			let NIDFromUrl = parseInt(window.location.pathname.replace('/',''));

			// option 2. get NID from a GET var
			if (isNaN(NIDFromUrl) && url.searchParams.has('nid')) {
				NIDFromUrl = parseInt(url.searchParams.get('nid'));
			}

			if (!isNaN(NIDFromUrl)) {
				const resultLogin = await handleLogin({networkId: NIDFromUrl});
				if (resultLogin !== true && resultLogin !== undefined) {
					notify('error', resultLogin);
				} else {
					notify('success', "Please wait ...");
					setShow(false);
				}
			}
		}

		checkNIDFromUrl();

	}, []);

	if (!show) {
		return [];
	}

	const handleSubmit = async (data, setShowLoader) => {

		setShowLoader(true);
		const result = await handleLogin(data)

		if (result !== true && result !== undefined) {
			notify('error', result);
			setShowLoader(false);
			return false;
		}

		notify('success', "Please wait ...");

		setShow(false);

		return true;
	};

	return <LoginForm logo={"logos/flow.png"} handlerSubmit = {handleSubmit} {...props} />;
}
